import { api } from "@/api"

type ChangeSelfMerchantGroupAdminPasswordBody = {
  password: string
}

export const changeMerchantGroupAdminPassword = async (
  params: ChangeSelfMerchantGroupAdminPasswordBody
) => {
  await api.post(
    "/merchant-group/merchant-group-admins/self/change-password/",
    {
      body: params,
      isMerchantGroup: true,
    }
  )
}
